// src/whatsappChat/components/WaChatNav.jsx
import React from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faInbox, faLayerGroup, faPlug } from '@fortawesome/free-solid-svg-icons';

export const WA_CHAT_PATH = '/whatsapp-chat';

/**
 * The module's own menu. The CRM sidebar is intentionally not involved.
 */
export function WaChatNav({ permissions, unreadCount = 0, unreadMore = false, live = null }) {
  const items = [
    { to: WA_CHAT_PATH, end: true, label: 'Inbox', icon: faInbox, show: permissions.inbox.view, badge: unreadCount },
    { to: `${WA_CHAT_PATH}/templates`, label: 'Templates', icon: faLayerGroup, show: permissions.templates.view },
    { to: `${WA_CHAT_PATH}/setup`, label: 'Setup', icon: faPlug, show: permissions.setup.view },
  ].filter((item) => item.show);

  return (
    <header className="wa-nav">
      <div className="wa-nav-brand">
        <span className="wa-nav-logo">
          <FontAwesomeIcon icon={faWhatsapp} />
        </span>
        <span className="wa-nav-title">WhatsApp Chat</span>
      </div>

      <nav className="wa-nav-items">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) => `wa-nav-item${isActive ? ' is-active' : ''}`}
          >
            <FontAwesomeIcon icon={item.icon} />
            <span>{item.label}</span>
            {item.badge > 0 && (
              <span className="wa-nav-badge" title="Chats with unread messages">
                {item.badge > 99 ? '99+' : `${item.badge}${unreadMore ? '+' : ''}`}
              </span>
            )}
          </NavLink>
        ))}
      </nav>

      {live !== null && (
        <span
          className={`wa-nav-live${live ? ' is-live' : ''}`}
          title={live ? 'Updates arrive instantly' : 'Live connection is down. Refreshing every few seconds.'}
        >
          <span className="wa-nav-live-dot" />
          {live ? 'Live' : 'Reconnecting…'}
        </span>
      )}
    </header>
  );
}
